export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
  // Doc noi dung bai post cua quang cao Click-to-Messenger.
  'pages_read_engagement',
  // Doc cay quang cao: tai khoan QC -> campaign -> adset -> ad.
  // 17/08/2026 lan 1: dialog chan "Invalid Scopes: ads_read, ads_management" vi app
  // chua co product Marketing API. Sau khi them product vao App Dashboard thi hai
  // scope nay moi ton tai. Neu lai thay "Invalid Scopes" thi product chua an.
  'ads_read',
  'ads_management',
  // Rieng BM doc duoc san bang business_management o tren, khong can ads_*:
  //   GET /2558616844556952?fields=id,name -> "BM BonBoz Clinic"
];

export const INSTAGRAM_SCOPES = [
  'instagram_basic',
  'instagram_manage_messages',
];

export const buildFacebookLoginScopes = ({
  includeInstagramScopes = false,
} = {}) => {
  const scopes = [...FACEBOOK_PAGE_SCOPES];
  if (includeInstagramScopes) {
    scopes.push(...INSTAGRAM_SCOPES);
  }
  return scopes.join(',');
};
